enum CampaignManagementTypes {
	GET_CAMPAIGNS = 'campaignManagement/GET_CAMPAIGNS',
	GET_CAMPAIGNS_SUCCESS = 'campaignManagement/GET_CAMPAIGNS_SUCCESS',
	GET_CAMPAIGNS_FAILURE = 'campaignManagement/GET_CAMPAIGNS_FAILURE',
	CREATE_CAMPAIGN_S3_URL = 'campaignManagement/CREATE_CAMPAIGN_S3_URL',
	CREATE_S3URL_SUCCESS = 'campaignManagement/CREATE_S3URL_SUCCESS',
	CREATE_S3URL_FAILURE = 'campaignManagement/CREATE_S3URL_FAILURE',
	CREATE_S3URL_UPLOADING = 'campaignManagement/CREATE_S3URL_UPLOADING',
	REMOVE_S3URL_UPLOADING = 'campaignManagement/REMOVE_S3URL_UPLOADING',
	CREATE_CAMPAIGN = 'campaignManagement/CREATE_CAMPAIGN',
	CREATE_CAMPAIGN_SUCCESS = 'campaignManagement/CREATE_CAMPAIGN_SUCCESS',
	CREATE_CAMPAIGN_FAILURE = 'campaignManagement/CREATE_CAMPAIGN_FAILURE',
	EDIT_CAMPAIGN = 'campaignManagement/EDIT_CAMPAIGN',
	EDIT_CAMPAIGN_SUCCESS = 'campaignManagement/EDIT_CAMPAIGN_SUCCESS',
	EDIT_CAMPAIGN_FAILURE = 'campaignManagement/EDIT_CAMPAIGN_FAILURE',
}

export default CampaignManagementTypes;
